<template>
  <div>
    <PageHead title="隐患问题整改申报"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">问题描述：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入问题"
                v-model="queryForm.hiddenDangerDescription"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">隐患级别：</div>
              <a-select
                allowClear
                placeholder="请选择隐患级别"
                class="w200"
                v-model="queryForm.hiddenDangerLevel"
              >
                <a-select-option :value="1">一般</a-select-option>
                <a-select-option :value="2"> 重大 </a-select-option>
              </a-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">检查类型：</div>
              <a-select
                allowClear
                placeholder="请选择检查类型"
                class="w200"
                v-model="queryForm.checkType"
              >
                <a-select-option :value="1">上级检查</a-select-option>
                <a-select-option :value="0"> 自查 </a-select-option>
              </a-select>
            </div>
          </div>
          <blank height="20"> </blank>
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">上报机构：</div>
              <a-tree-select
                allowClear
                v-model="queryForm.reportOrganizationId"
                class="w200"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择上报机构"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName'
                }"
              >
              </a-tree-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">整改状态：</div>
              <a-select
                allowClear
                placeholder="请选择整改状态"
                v-model="queryForm.rectificationStatus"
                class="w200"
              >
                <a-select-option :value="1">已整改</a-select-option>
                <a-select-option :value="0"> 未整改 </a-select-option>
              </a-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">表单状态：</div>
              <a-select
                allowClear
                placeholder="请选择表单状态"
                class="w200"
                v-model="queryForm.state"
              >
                <a-select-option :value="0">待提交</a-select-option>
                <a-select-option :value="1">正在审批</a-select-option>
                <a-select-option :value="2">已归档</a-select-option>
                <a-select-option :value="3">退回</a-select-option>
                <!-- <a-select-option :value="4">取消</a-select-option> -->
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-item">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <div class="mb20 search-btns mt20">
        <a-button type="primary" @click="goDetial()" icon="plus">
          新建</a-button
        >
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>
      <div class="operating-steps mb20">
        <div class="operating-steps-item">
          <img class="roster-clear-img" src="./img/plaint.svg" alt="" />
          <div class="roster-clear-num">
            数量统计 未整改：<a-button type="link"> {{ noCount }} </a-button>
            已整改：<a-button type="link"> {{ yesCount }} </a-button>
          </div>
          <a-select
            placeholder="全部"
            style="width: 100px"
            class="operating-time"
            size="small"
            v-model="queryForm.reportTime"
          >
            <a-select-option
              v-for="item in reportTimeList"
              :value="item.valuename"
              :key="item.id"
            >
              {{ item.keyname }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>

        <span slot="hiddenDangerLevel" slot-scope="text">
          <span v-if="text == 1"> 一般 </span>
          <span v-if="text == 2"> 重大 </span>
        </span>
        <span slot="checkType" slot-scope="text">
          <span v-if="text == 1"> 上级检查 </span>
          <span v-if="text == 0"> 自查 </span>
        </span>
        <span slot="rectificationStatus" slot-scope="text">
          <span v-if="text == 1"> 已整改 </span>
          <span v-if="text == 0"> 未整改 </span>
        </span>
        <div slot="status" class="statusDiv" slot-scope="text">
          <div v-if="text == 0" class="dot0 mr5"></div>
          <div v-if="text == 1" class="dot1 mr5"></div>
          <div v-if="text == 2" class="dot2 mr5"></div>
          <div v-if="text == 3" class="dot3 mr5"></div>
          <div v-if="text == 4" class="dot4 mr5"></div>
          <span v-if="text == 0"> 待提交 </span>
          <span v-if="text == 1"> 正在审批 </span>
          <span v-if="text == 2"> 已归档 </span>
          <span v-if="text == 3"> 退回 </span>
          <span v-if="text == 4"> 取消 </span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button
            type="link"
            class="btn-link"
            @click="goDetial(record.id, 1)"
          >
            查看
          </a-button>

          <!-- 未提交可修改 -->
          <template v-if="record.state == 0">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="goDetial(record.id)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record.id)"
            >
              删除
            </a-button> </template
          ><a-divider type="vertical" v-if="record.recallButton" />
          <a-button
            v-if="record.recallButton"
            type="link"
            class="btn-link"
            @click="showRecallConfirm(record)"
          >
            撤回
          </a-button>

          <a-divider type="vertical" />
          <a-button type="link" class="btn-link" @click="history(record.id)">
            历史记录
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
    <a-modal
      v-model="ishistory"
      title="历史修改记录"
      :footer="null"
      :width="800"
    >
      <a-table
        :pagination="false"
        :columns="historyColumns"
        :data-source="historyList"
        :row-key="(record) => record.fromVersion"
      >
        <div slot="action" slot-scope="text, record">
          <a-button
            type="link"
            class="btn-link"
            @click="goHistoryDetial(record.id, record.version)"
          >
            查看
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="historyPage"
          :default-current="historyPage"
          :total="historyTotal"
          :pageSize="historySize"
          @change="historyPageChange"
        />
      </div>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 80,
    align: 'center'
  },
  {
    title: '隐患问题描述',
    dataIndex: 'hiddenDangerDescription',
    key: 'hiddenDangerDescription',
    ellipsis: true
  },
  {
    title: '上报机构',
    dataIndex: 'organizationName',
    key: 'organizationName',
    ellipsis: true
  },
  {
    title: '上报人',
    dataIndex: 'reportPersonName',
    key: 'reportPersonName',
    ellipsis: true
  },
  {
    title: '隐患级别',
    dataIndex: 'hiddenDangerLevel',
    key: 'hiddenDangerLevel',
    scopedSlots: { customRender: 'hiddenDangerLevel' },
    ellipsis: true
  },
  {
    title: '检查类型',
    dataIndex: 'checkType',
    key: 'checkType',
    scopedSlots: { customRender: 'checkType' },
    ellipsis: true
  },
  {
    title: '整改状态',
    dataIndex: 'rectificationStatus',
    key: 'rectificationStatus',
    scopedSlots: { customRender: 'rectificationStatus' },
    ellipsis: true
  },

  {
    title: '表单状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'status' },
    ellipsis: true
  },
  {
    title: '上报时间',
    dataIndex: 'reportTime',
    key: 'reportTime',
    ellipsis: true
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    width: 260,
    align: 'left'
  }
]
const historyColumns = [
  {
    title: '时间',
    dataIndex: 'createTime',
    key: 'createTime'
  },

  {
    title: '修改人',
    dataIndex: 'modifyUserName',
    key: 'modifyUserName',
    ellipsis: true
  },

  {
    title: '表单版本',
    dataIndex: 'fromVersion',
    key: 'fromVersion'
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'center'
  }
]
import { mapState, mapActions } from 'vuex'
import { getHiddenDanger, delHiddenDanger, getHistoryList } from './api/api'
import { recallProcessFn } from '@/utils/utils'
export default {
  data() {
    return {
      queryForm: {},
      data: [],
      columns,
      historyColumns,
      ishistory: false,
      historyList: [], //历史版本列表
      historyPage: 1,
      historyTotal: 0,
      historySize: 5,
      historyId: '', // 被查看历史版本的人id
      noCount: 0,
      yesCount: 0,
      total: 0,
      page: 1,
      size: 10,
      loading: false
    }
  },
  computed: {
    ...mapState({
      treeData: (state) => state.app.treeData, // 组织机构树
      reportTimeList: (state) => state.bytype.reportTimeList // 时间
    })
  },
  created() {
    this.getorganizeListFn()
    this.getreportTime()
    this.load()
  },
  methods: {
    // 提交 未审批 可撤回流程
    showRecallConfirm(record) {
      const recallProcessPromise = new Promise((resolve, reject) => {
        recallProcessFn(
          this,
          record,
          resolve,
          reject,
          'hidden-danger-rectification'
        )
      })
      recallProcessPromise
        .then((value) => {
          console.log(value)
          this.load()
        })
        .catch((error) => {
          console.log(error)
          this.load()
        })
    },
    ...mapActions(['getorganizeListFn', 'getreportTime']),

    // 组织树递归查找某一机构
    getTreeIt(dt, n) {
      let that = this
      var value = null
      for (const ev of dt) {
        if (ev.id == n) {
          value = ev
          break
        } else {
          if (ev.treeList && ev.treeList.length > 0) {
            const obj = that.getTreeIt(ev.treeList, n)
            if (obj) {
              return obj
            }
          }
        }
      }
      return value
    },
    treeChange(e) {
      let treeIt = this.getTreeIt(this.treeData, e)
      if (treeIt) {
        return treeIt.organizationName //获取上报机构
      } else {
        return e
      }
    },
    // 拉取列表
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      getHiddenDanger(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data.hdrectifications
          this.yesCount = res.data.data.yesCount
          this.noCount = res.data.data.noCount
          this.total = res.data.count
        }
      })
    },
    history(id) {
      //查看历史记录
      this.historyId = id
      this.historyLoad()
      this.ishistory = true
    },
    historyLoad() {
      // 获取历史版本列表
      let params = {
        id: this.historyId,
        page: this.historyPage,
        size: this.historySize
      }
      getHistoryList(params).then((res) => {
        if (res.data.code == 0) {
          this.historyList = res.data.data
          this.historyTotal = res.data.count
        }
      })
    },
    // 历史记录分页
    historyPageChange(pageNumber) {
      this.historyPage = pageNumber
      this.historyLoad()
    },
    goHistoryDetial(id, version) {
      this.$router.push({
        path: '/PotentialSafetyHazardDetial',
        query: {
          id,
          version,
          isEdit: '1'
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          delHiddenDanger(id).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },

    goDetial(id, type) {
      if (type) {
        this.$router.push('/PotentialSafetyHazardDetial?id=' + id + '&isEdit=1')
      } else {
        if (id) {
          this.$router.push('/PotentialSafetyHazardDetial?id=' + id)
        } else {
          this.$router.push('/PotentialSafetyHazardDetial')
        }
      }
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    },
    cancel() {
      //取消
      this.queryForm = {}
    },
    subMit() {
      this.page = 1
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 200px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        .query-view-lable {
          width: 90px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}
.operating-steps {
  color: rgba(230, 247, 255, 1);
  background-color: rgba(230, 247, 255, 1);
  box-shadow: rgba(186, 231, 255, 1) solid 1px;
  border-radius: 4px;
  .roster-clear-img {
    width: 20px;
    height: 20px;
  }
  .roster-clear-num {
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
  }
  .operating-steps-item {
    // height: 35px;
    line-height: 35px;
    margin-left: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    text-align: left;
    position: relative;
    .operating-time {
      position: absolute;
      right: 50px;
    }
  }
}
.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/PotentialSafetyHazard/index.vue